export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["En"] = "en";
    LanguageCode["Sv"] = "sv";
})(LanguageCode || (LanguageCode = {}));
